import { AxiosRequestConfig } from 'axios'
import { apiInstance } from './instance'

type SilentRequestConfig = AxiosRequestConfig & {
  suppressGlobalErrorHandler: boolean
}

interface SocketTicketResponse extends ApiResponseBase {
  ticket?: string
  expiresIn?: number
}

const silentRequestConfig: SilentRequestConfig = {
  suppressGlobalErrorHandler: true,
}

export const getSocketTicket = async () => {
  const res = await apiInstance.get<SocketTicketResponse>(
    '/api/v1/socket/ticket',
    silentRequestConfig,
  )
  const { code, message, ticket } = res.data

  if (code !== 200 || !ticket) {
    throw new Error(message || 'Socket ticket was not issued.')
  }

  return ticket
}

export const withSocketTicket = async (url: string) => {
  const ticket = await getSocketTicket()
  const nextUrl = new URL(url)
  nextUrl.searchParams.set('ticket', ticket)
  return nextUrl.toString()
}
